import { render, staticRenderFns } from "./OrganizationComponent.vue?vue&type=template&id=958e71de&scoped=true&"
import script from "./OrganizationComponent.vue?vue&type=script&lang=js&"
export * from "./OrganizationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958e71de",
  null
  
)

export default component.exports